import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable} from "rxjs/internal/Observable";
import * as fromSpecialOffersActions from '../actions/special-offers.actions';
import {catchError, map, switchMap} from "rxjs/operators";
import {of} from "rxjs/internal/observable/of";
import {InvoicesRestService} from "../../services/api/invoices.rest-service";
import {WebshopRestService} from "../../services/api/webshop-rest.service";
import {ProductsResponse} from '../../models/shop/products-response.model';
import {ProductType} from '../../models/shop/product-type.model';

@Injectable()
export class SpecialOffersEffects {
    /**
     * In case of SearchInvoicesAction we're going to call the InvoicesService and then
     * we'll post a LoadInvoicesCompleteAction to the reducer or in case of failure
     * LoadInvoicesFailAction
     *
     * @type {Observable<any>}
     */
    @Effect()
    loadSpecialOffers$: Observable<any> = this.actions$
        .pipe(ofType<fromSpecialOffersActions.LoadSpecialOffersAction>(fromSpecialOffersActions.SpecialOffersActionTypes.LOAD_PIN))
        .pipe(map(action => action.payload), switchMap((productRequest) =>
            this.productRestService.loadSpecialOffers(productRequest).pipe(
                switchMap(data => {
                    const prodResp = new ProductsResponse({...data.returnObject, ...{type: ProductType.OffersPin}});
                    if (productRequest.page === 1) {
                        return [new fromSpecialOffersActions.LoadSpecialOffersCompleteAction(prodResp), new fromSpecialOffersActions.GetBatchFromCacheAction()];
                    } else {
                        return [new fromSpecialOffersActions.LoadSpecialOffersCompleteAction(prodResp)]
                    }
                }),
                catchError((error) => of(new fromSpecialOffersActions.LoadSpecialOffersFailAction(error)))
            )
        ));

    @Effect()
    searchSpecialOffers$: Observable<any> = this.actions$
        .pipe(ofType<fromSpecialOffersActions.SearchShopAction>(fromSpecialOffersActions.SpecialOffersActionTypes.SEARCH_PIN))
        .pipe(map(action => action.payload), switchMap((productRequest) => [new fromSpecialOffersActions.LoadSpecialOffersAction(productRequest)]));

    /**
     * @param {InvoicesRestService} productRestService
     * @param {Actions} actions$
     */
    constructor(
        private productRestService: WebshopRestService,
        private actions$: Actions
    ) {
    }
}
